import { AbacoWebModule, ApplicationReadyEvent } from '@abaco/web-common/src/app';
import globals from "./globals";
import ExampleVuexModule from './state';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import ThermoApi from './api/ThermoApi';
import FarmRegistryModule from "@abaco/farm-registry/src/modules/farm-registry/index";
import DashboardModule from "@abaco/dashboard-module/src/modules/dashboard";
import DashboardChartModule from "@abaco/dashboard-module/src/modules/charts"
import SupplyChainViewModule from "@abaco/supply-chain-view-module/src/modules/supply-chain-view-module";
import routes from "./routes";

export const MODULE_ID = "thermo_widget_module";

export default class ThermoWidgetModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private thermoApi!: ThermoApi;
    private apiCreated = false;

    private http!: HTTPClient;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;
    readonly vuexModule = new ExampleVuexModule();
    readonly routes = routes;

    dependsOn = {
        [DashboardModule.MODULE_ID]: () => new DashboardModule(),
        [FarmRegistryModule.MODULE_ID]: () => new FarmRegistryModule(),
        [DashboardChartModule.MODULE_ID]: () => new DashboardChartModule(),
        [SupplyChainViewModule.MODULE_ID]: () => new SupplyChainViewModule()
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        this.http = evt.http;
    }

    async beforeEnterAnyRoutes(http: HTTPClient){
        if(this.apiCreated){
            return;
        }
        this.apiCreated = true;
        const ThermoApi = (await import("./api/ThermoApi")).default;
        this.thermoApi = new ThermoApi(http);
    }

    public get thermoWidgetApi(){
        return this.thermoApi;
    }

}
